import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class BatchInvoice implements MutableValue {
  public isNew = true;

  constructor(
    private fInvoiceId: string,
    private fBatchPlushieId: string,
    private fBulkProjectId: string,
    private fUsedDepositPercent: number,
    private fPreviouslyInvoicedAmount: number,
    private fShippingAmount?: number
  ) {
    [
      fInvoiceId,
      fBatchPlushieId,
      fBulkProjectId,
      fUsedDepositPercent,
      fPreviouslyInvoicedAmount,
    ].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fInvoiceId;
  }

  get invoiceId(): string {
    return this.fInvoiceId;
  }

  get batchPlushieId(): string {
    return this.fBatchPlushieId;
  }

  get bulkProjectId(): string {
    return this.fBulkProjectId;
  }

  get usedDepositPercent(): number {
    return this.fUsedDepositPercent;
  }

  get previouslyInvoicedAmount(): number {
    return this.fPreviouslyInvoicedAmount;
  }

  get shippingAmount(): number | undefined {
    return this.fShippingAmount;
  }
}
